import {
  DataName,
  DataType,
  InitialFormValues,
  PasswordFormValues,
  UserData,
} from './types';

export const DATA_TYPE: DataType = {
  phoneNumber: 'sms',
  email: 'email',
};

export const INITIAL_FORM_VALUES: InitialFormValues = {
  phoneNumber: '',
  email: '',
  name: 'phoneNumber',
};

export const PASSWORD_FORM_VALUES: PasswordFormValues = {
  newPass: '',
  login: '',
};

export const TABS_OPTIONS = [
  { label: 'Номер телефона', id: DataName.PHONE },
  { label: 'Email', id: DataName.EMAIL },
];

export const USER_DATA_INITIAL_STATE: UserData = {
  requisite: '',
  attemptsLeft: 0,
  attemptsTotal: 3,
  resendDate: '',
  serverTime: '',
  type: '',
  token: '0',
  disabled: false,
  checked: false,
  codeError: null,
};

export const CHECK_TIME_DELAY = 2000;
